export enum LocationWidgetSettingsMode {
  Cmc = "Cmc",
  Cfs = "Cfs"
}

export enum SmartPagePhoneNumberType {
  None = "None",
  Location = "Location",
  Custom = "Custom"
}

export enum SmartPageWebsiteType {
  None = "None",
  Location = "Location",
  Brand = "Brand",
  Custom = "Custom"
}
